import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import VideoCard from "@/components/VideoCard";
import BottomNav from "@/components/BottomNav";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function Watch() {
    const { productId } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [muted, setMuted] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get(`/products/${productId}`);
                setProduct(data);
            } catch (err) {
                console.error("Watch load failed", err?.response?.status);
                setProduct(null);
            } finally {
                setLoading(false);
            }
        })();
    }, [productId]);

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-black">
                <Loader2 className="w-8 h-8 animate-spin text-[#FF5722]" />
            </div>
        );
    }

    if (!product) {
        return (
            <div className="min-h-screen bg-[#050505] text-white flex flex-col items-center justify-center px-6">
                <p className="font-body text-white/70 mb-4">Vidéo introuvable</p>
                <button
                    onClick={() => navigate("/feed")}
                    data-testid="watch-back-feed"
                    className="orange-btn h-11 px-5 rounded-full font-body font-bold"
                >
                    Retour au feed
                </button>
            </div>
        );
    }

    return (
        <div className="relative bg-black" data-testid="watch-page">
            {/* Back button */}
            <div className="fixed top-4 left-4 z-50">
                <button
                    onClick={() => navigate(-1)}
                    data-testid="watch-back-btn"
                    className="w-11 h-11 rounded-full glass flex items-center justify-center active:scale-95"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
            </div>

            <VideoCard
                product={product}
                active={true}
                muted={muted}
                onToggleMute={() => setMuted((m) => !m)}
            />

            <BottomNav />
        </div>
    );
}
